export default "__VITE_ASSET__WcohMsIG__"